import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import Colors from '../../constants/Colors';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexShrink: 1,
  },
  message: {
    color: Colors.veryDarkGray,
    fontSize: 14,
  },
  messageContainer: {
    flexShrink: 1,
  },
  icon: {
    marginRight: 16,
  },
});

interface Props {
  userCanVisit: boolean;
  message: string;
}

/**
 * Presentational helper component for displaying the icon and summary message side-by-side.
 */
export function UserVisitSummaryWithIcon(props: Props) {
  return (
    <View style={styles.container}>
      <MaterialIcons
        style={styles.icon}
        name={props.userCanVisit ? 'check-circle' : 'error'}
        size={24}
        color={props.userCanVisit ? Colors.primaryColor : Colors.warningBackground}
      />
      <View style={styles.messageContainer}>
        <Text style={styles.message}>{props.message}</Text>
      </View>
    </View>
  );
}
